export const STRING = 'String'
